import React from 'react';
import { Menu } from 'lucide-react';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import RightSideBar from '@/js/components/ManufacturerRegistration/RightSideBar';
import LeftSidebar from '@/js/components/sidebars/LeftSidebar';
import SidebarSheetWrapper from '@/js/components/sidebars/SidebarSheetWrapper';
import BuyerProfileScreen from '@/js/screens/Supplier/BuyerProfileScreen';

const BuyerProfile = ({ data }) => {
  return (
    <div className="flex min-h-[calc(100vh-70px)] w-full overflow-hidden">
      {/* Mobile Sidebar (Drawer) */}
      <div className="lg:hidden p-4">
        <Drawer>
          <DrawerTrigger asChild>
            <Menu size={28} className="cursor-pointer mt-7 ml-5" />
          </DrawerTrigger>
          <DrawerContent>
            <div className="mx-auto w-full max-w-sm">
              <DrawerHeader>
                <DrawerTitle>Menu</DrawerTitle>
              </DrawerHeader>
              <LeftSidebar role="supplier" />
              <DrawerClose asChild>
                <Button variant="outline" className="w-full">
                  Close
                </Button>
              </DrawerClose>
            </div>
          </DrawerContent>
        </Drawer>
      </div>

      {/* Desktop Sidebar (Left) */}
      <div className="hidden lg:flex w-[5%] flex-shrink-0 shadow-md">
        <div className="side-menu w-full h-full pt-5">
          <SidebarSheetWrapper role="supplier" />
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col px-6 overflow-hidden">
        <BuyerProfileScreen />
      </div>
      {/* Right Sidebar (Hidden on Mobile) */}
      <div className="hidden lg:flex w-[24%] flex-shrink-0 shadow-md">
        <div className="side-menu pl-5 w-full">
          <RightSideBar role="supplier" />
        </div>
      </div>
    </div>
  );
};

export default BuyerProfile;
